export default "dist/furniture/bg_body.png";